"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('select2');
require('./../scss/sites/originallongdrink/originallongdrink.scss');
const index_1 = require("./../js/index");
const originallongdrink_1 = require("./../js/Sites/originallongdrink");
const ProductsApp_originallongdrink_1 = require("./ReactComponents/Products/ProductsApp-originallongdrink");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
(0, originallongdrink_1.InitOriginalLongDrink)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
// Initialize and mount react components
(0, index_1.InitReact)(Object.assign(Object.assign({}, index_1.DefaultComponentTypes), { ProductsApp: ProductsApp_originallongdrink_1.default }));
$(document).ready(function () {
    $("body").on("click", ".play-audio", function (e) {
        e.preventDefault();
        let audioPlayer = e.currentTarget.parentNode.firstElementChild;
        audioPlayer.play();
    });
    $("body").on("click", ".play-video", function (e) {
        e.preventDefault();
        let videoId = $(this).data("video-id");
        let iframeId = $(this).data("iframe-id");
        let hideControls = $(this).data("hide-controls");
        let videoElem = document.getElementById("video-" + videoId);
        let iframeElem = document.getElementById("iframe-" + iframeId);
        if (videoElem) {
            videoElem.controls = hideControls !== "True";
            videoElem.play();
            $(this).closest(".o-video-thumbnail").hide();
        }
        else if (iframeElem) {
            $(iframeElem).show();
            $(this).closest(".o-video-thumbnail").hide();
        }
    });
    $("body").on("click", ".o-scroll-hero .o-round-button", function (e) {
        $("html, body").animate({ scrollTop: $(window).height() });
    });
    //Initialize select2 for Happyjoe Contact form
    $('.Form__Element.FormSelection select').hide();
    $('.Form__Element.FormSelection select').select2({
        minimumResultsForSearch: Infinity,
        width: 'resolve',
        dropdownParent: $('.Form__MainBody')
    });
    $('.o-history-event').hover(function () {
        var history_event_id = $(this).attr('data-event');
        $(".bg-image").removeClass("is-active");
        $("." + history_event_id).addClass("is-active");
        //console.log('hover' + $(this).attr('data-background'));
        if ($(this).data('dimfilter') === "True") {
            $('.js-dimfilter').show();
        }
        //$('.o-history-selected .bg-image.bg-hires').css('background-image', 'url(' + $(this).attr('data-background') + '?width=' + Math.ceil($('.o-history-selected').width()) + '&height=' + Math.ceil($('.o-history-selected').height()) + '&mode=crop), url(' + $(this).attr('data-background') + '?width=' + Math.ceil($('.o-history-selected').width() / 100) + '&height=' + Math.ceil($('.o-history-selected').height() / 100) + '&mode=crop)');
        //$('.o-history-selected .bg-image.bg-hires').css('background-image', 'url(' + $(this).attr('data-background') + '?width=' + Math.ceil($('.o-history-selected').width()) + '&height=' + Math.ceil($('.o-history-selected').height()) + '&mode=crop)');
        //$('.o-history-selected .bg-image.bg-lores').css('background-image', 'url(' + $(this).attr('data-background') + '?width=' + Math.ceil($('.o-history-selected').width() / 100) + '&height=' + Math.ceil($('.o-history-selected').height() / 100) + '&mode=crop)');
        $('.o-history-section').addClass('active');
        $('.o-history-event').each(function () {
            $(this).removeClass('active');
        });
        $('.o-history-folders div').each(function () {
            $(this).removeClass('active');
        });
        $(this).addClass('active');
        $('.o-history-folders [data-folder="' + $(this).attr('data-folder') + '"]').addClass('active');
    });
    $('.o-history-gindex').hover(function () {
        $(".bg-image").removeClass("is-active");
    });
    $('.o-history-section, .o-history-event').mouseleave(function () {
        $('.o-history-event').each(function () {
            $(this).removeClass('active');
        });
        $(this).removeClass('active');
    });
    $('.o-history-event').mouseleave(function () {
        //$('.o-history-selected .bg-image.bg-hires').css('background-image', 'none');
        //$('.o-history-selected .bg-image.bg-lores').css('background-image', 'none');
        $('.js-dimfilter').hide();
    });
});
// Import site specific scripts
//require("./Sites/originallongdrink");
